import { useState, useEffect } from 'react';

import ProjectsSlider from '../ProjectsSlider/ProjectsSlider';
import './Projects.css';

function Projects() {
  const [projectsFade, setProjectsFade] = useState({
    fade: 'fade-out',
    position: 'top',
  });

  useEffect(() => {
    const timeout = setInterval(() => {
      if (projectsFade.fade === 'fade-out') {
        setProjectsFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
    }, 200);
    return () => clearInterval(timeout);
  }, [projectsFade]);

  const projects = [
    {
      name: 'Eos',
      description:
        'E-commerce de retail reportivo. Es el proyecto del curso FullStack de Digital House.',
      url: 'https://eos-streetwear.herokuapp.com/',
      repo: 'https://github.com/marianopedrini/Grupo_9_EOS',
      logo: 'logo-eos.png',
      logoAlt: 'logo Eos Streetwear',
      img: 'eos.png',
      techs: 'HTML, CSS, JS, Nodejs, Express',
    },
    {
      name: 'Lpharma',
      description: 'Consultora Farmacéutica',
      url: 'https://lpharmaconsultores.com/',
      logo: 'logo-lpharma.png',
      logoAlt: 'logo Lpharma Consultores',
      img: 'lpharma.png',
      techs: 'HTML, CSS, JS',
    },
    {
      name: 'Studio Ghibli',
      description: 'Catálogo de películas de Studio Ghibli',
      url: 'https://ghibli-mp.netlify.app/',
      logo: 'ghibli.png',
      repo: 'https://github.com/marianopedrini/studio-ghibli-app',
      techs: 'Html, Css, Js, React, Tailwind',
    },
    {
      name: 'Viejo Portfolio',
      description: 'Portfolio anterior',
      url: 'https://marianopedrini.netlify.app/',
      repo: 'https://github.com/marianopedrini/web-personal',
      img: 'old-portfolio.png',
      techs: 'HTML, CSS, JS',
    },
  ];

  return (
    <div
      className={`projects-container ${projectsFade.fade} ${projectsFade.position}`}
    >
      <ProjectsSlider projects={projects} />
    </div>
  );
}

export default Projects;
